// extracted by mini-css-extract-plugin
export default {"body":"vGk4ZKuG9IkJbGzzG0ld","article":"E_8pUXBUfoayBCQ2mfAv"};